import { render, staticRenderFns } from "./BillReceivebleReport.vue?vue&type=template&id=795f0248&scoped=true"
import script from "./BillReceivebleReport.vue?vue&type=script&lang=js"
export * from "./BillReceivebleReport.vue?vue&type=script&lang=js"
import style0 from "./BillReceivebleReport.vue?vue&type=style&index=0&id=795f0248&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795f0248",
  null
  
)

export default component.exports